import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import * as ObjectActions from './main.actions';
import {
  IAllowedDomain,
} from './main.model';
import { MonitoringService } from '../../shared/service/error-service/monitoring.service';
import { STATIC_MAX_LIMIT_OF_CRUD } from '../../../constants';
import { MainService } from './main.service';
import { GetManyResponseInterface } from '../../shared/model/interface/crud-response-interface.model';

@Injectable()
export class MainEffects {
  constructor(
    private actions$: Actions<ObjectActions.MainActions>,
    private http: HttpClient,
    private injector: Injector,
    private monitoringService: MonitoringService,
    private readonly mainService: MainService,
  ) {}

  private MAIN_URLS = {
    POST: {
      SWITCH_HOME_PAGE: '/api/switch-home-page',
    },
  };

  @Effect()
  getAllowedDomains$ = this.actions$.pipe(
    ofType(ObjectActions.MainActionTypes.AllowedDomains),
    switchMap((objectData: ObjectActions.AllowedDomains) => {
      const params: HttpParams = new HttpParams().set('limit', STATIC_MAX_LIMIT_OF_CRUD);

      return this.mainService.getAllowedDomains(params).pipe(
        switchMap((response: GetManyResponseInterface<IAllowedDomain>) => {
          return of(new ObjectActions.AllowedDomainsCompleted(response.data));
        }),
        catchError((error) => {
          return of(new ObjectActions.FetchError(error));
        }),
      );
    }),
    catchError((error) => {
      return of(new ObjectActions.FetchError(error));
    }),
  );
}
